import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/customer-view') {
      setIsProducts(!isProducts);
      setIscurrentState("Payments");
    }
  }, [location.pathname]);
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isCategories, setIsCategories] = useState(false);
  const [isWebsites, setIsWebsites] = useState(false);
  const [isProducts, setIsProducts] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");



  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboards") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Categories") {
      setIsCategories(false);
    }
    if (iscurrentState !== "Products") {
      setIsProducts(false);
    }
   
    if (iscurrentState !== "Websites") {
      setIsWebsites(false);
    }


  }, [
    history,
    iscurrentState,
    isDashboard,
    isCategories,
    isWebsites,
    isProducts,

  ]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboards",
      icon: "mdi mdi-speedometer",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "categories",
      label: "Categories",
      icon: "mdi mdi-view-grid-outline",
      link: "/categories",
      click: function (e) {
        e.preventDefault();
        setIsCategories(!isCategories);
        setIscurrentState("Categories");
        updateIconSidebar(e);
      },
    },

    // {
    //   id: "categories",
    //   label: "Categories",
    //   icon: "mdi mdi-view-grid-outline",
    //   link: "/#",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsCategories(!isCategories);
    //     setIscurrentState("Categories");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isCategories,
    //   subItems: [
    //     {
    //       id: "category",
    //       label: "Category",
    //       link: "/categories",
    //       parentId: "categories",
    //     },
    //     {
    //       id: "sub-category",
    //       label: "Sub Category",
    //       link: "/waiting-for-dispatch",
    //       parentId: "categories",
    //     },
       
    //   ],
    // },
    // {
    //   id: "products",
    //   label: "Products",
    //   icon: "mdi mdi-package-variant-closed",
    //   link: "/products",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsProducts(!isProducts);
    //     setIscurrentState("Products");
    //     updateIconSidebar(e);
    //   },
    // },
   

    {
      id: "websitesSettings",
      label: "Websites Settings",
      icon: "mdi mdi-web",
      link: "/website-settings",
      click: function (e) {
        e.preventDefault();
        setIsWebsites(!isWebsites);
        setIscurrentState("Websites");
        updateIconSidebar(e);
      },
    },






  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
